import { render, staticRenderFns } from "./UnderMaintenance.vue?vue&type=template&id=37cf0150"
import script from "./UnderMaintenance.vue?vue&type=script&lang=js"
export * from "./UnderMaintenance.vue?vue&type=script&lang=js"
import style0 from "./UnderMaintenance.vue?vue&type=style&index=0&id=37cf0150&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports